module.exports = __webpack_public_path__ + "static/media/AMTUserManual.0a4fb35d.pdf";